import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Per-route Open Graph + Twitter Card meta block.
 *
 * Renders the canonical six tags (og:title, og:description, og:image, og:type,
 * twitter:card, twitter:image) plus an absolute <title> override.
 *
 * Image URLs MUST be absolute and publicly fetchable (social scrapers cannot
 * go through our auth-prefixed image proxy) — use the raw customer-assets
 * CDN URL, not the proxied one.
 *
 * Defaults fall back to the BTT app-level meta defined in BTTApp.jsx.
 */
const DEFAULT_OG_IMAGE =
  'https://customer-assets.emergentagent.com/job_87e28a3d-66d8-4503-ad2a-42e59c9e6067/artifacts/n8buf17t_BeTheTrain_HomePage.png';

export const OgMeta = ({ title, description, image, type = 'website', testId }) => {
  const ogImage = image || DEFAULT_OG_IMAGE;
  return (
    <Helmet data-testid={testId}>
      {title ? <title>{title}</title> : null}
      {description ? <meta name="description" content={description} /> : null}

      {/* Open Graph */}
      {title ? <meta property="og:title" content={title} /> : null}
      {description ? <meta property="og:description" content={description} /> : null}
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content={type} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      {title ? <meta name="twitter:title" content={title} /> : null}
      {description ? <meta name="twitter:description" content={description} /> : null}
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default OgMeta;
